module.exports = __webpack_public_path__ + "fonts/iconfont.04bf41ea.woff";